export enum OnboardingType {
  Default = "default",
  Custom = "custom",
}
